import * as React from 'react';
import { Typography } from '@mui/material';
import { TeacherPromoCard } from '../elements/teacher-promo-card';
import { Teachers } from '../../types/blocks/teachers';
import { CallToActionButton } from '../elements/call-to-action-button';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { commonSwiperConfig, EventBus } from '@/shared/utils';
import { DynamicPageEvents } from 'src/components/containers/dynamic-page/events';

interface SectionBestTeachersProps {
  element: Teachers;
  eventBus: EventBus<DynamicPageEvents>;
}

export const SectionBestTeachers: React.FC<SectionBestTeachersProps> = ({ element, eventBus }) => {
  const middleIndex = Math.floor(element.teachers.length / 2);

  return (
    <div className="relative py-24 space-y-16">
      <div className="space-y-16">
        <div className="mb-2 px-4 w-full lg:w-[750px] text-center mx-auto">
          <div className="space-y-2 mb-8">
            <Typography variant="h1" color="textPrimary" component="h2">
              {element.title}
            </Typography>
            <Typography
              variant="s1"
              color="textSecondary"
              component="p"
              className="leading-6 md:leading-7"
            >
              {element.description}
            </Typography>
          </div>
          <CallToActionButton button={element.callToAction} />
        </div>

        <div>
          <div className="relative w-screen">
            <div className="absolute left-0 bottom-0 h-full w-32 bg-gradient-to-r from-[#1C1D22] to-transparent z-10 pointer-events-none" />
            <div className="absolute right-0 bottom-0 h-full w-32 bg-gradient-to-l from-[#1C1D22] to-transparent z-10 pointer-events-none" />
            <Swiper
              {...commonSwiperConfig}
              spaceBetween={16}
              slidesPerView="auto"
              watchOverflow={false}
              centeredSlides={true}
              initialSlide={middleIndex}
              loop
            >
              {element.teachers.map((teacher) => (
                <SwiperSlide key={teacher.id} className="w-[300px]">
                  <TeacherPromoCard
                    eventBus={eventBus}
                    href={teacher.href || undefined}
                    imageUrl={
                      teacher.image?.url || '/assets/images/placeholder/card-placeholder.png'
                    }
                    name={`${teacher.name} ${teacher.surname}`}
                    instruments={teacher.instruments.map((el) => ({
                      ...el,
                      image: el.image?.url,
                    }))}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};
